<script setup>
import { usePage } from "@inertiajs/vue3";
import { computed } from "vue";
import { useLocale } from "vuetify";
import { useThemeSetting } from "@/Composable/ThemeSetting";

defineProps({
  withStyle: {
    type: Boolean,
    default: false,
  },
  forNavbar: {
    type: Boolean,
    default: false,
  },
  transparentMode: {
    type: Boolean,
    default: false,
  },
});
const page = usePage();
const { isDark } = useThemeSetting();
const locale = computed(() => {
  return page.props.locale;
});
const allLocale = computed(() => {
  return page.props.allLocale;
});
const { current } = useLocale();
const loclase = page.props.allLocale;

function getObjKey(obj, value) {
  return Object.keys(obj).find((key) => obj[String(key)] === String(value));
}

const currentName = computed(() => {
  try {
    return allLocale.value[page.props.locale].properties.native;
  } catch (error) { }
});

const changeLocale = (langCode, href) => {
  if (langCode !== page.props.locale) {
    window.location.href = href;
  }
};
</script>
<style scoped></style>
<template>
  <v-menu offset-y :elevation="isDark ? 9 : 8" v-if="!forNavbar">
    <!-- Activator -->
    <template v-slot:activator="{ props }">
      <v-btn variant="text" size="small" slim v-bind="props">
        <svg width="30" height="30" style="max-width: 30px;" :class="[
          transparentMode ? 'text-white' : (isDark ? 'nav-svg-dark-color-mode' : ''),
          'opacity-90 dark:opacity-100'
        ]" :style="transparentMode ? 'filter: brightness(0) invert(1);' : ''">

          <image xlink:href="/assets/svgicons/translate-01.svg" width="30" height="30" />
        </svg>
        <span :class="transparentMode ? 'text-white' : 'text-gray-800 dark:text-white'" class="text-sm px-2">{{
          __t(currentName) }}</span>
      </v-btn>

      <!-- <v-btn density="compact" color="on-background" v-bind="props" variant="text" class="p- 2 w- max" elevation="0"
        plain :ripple="true" stacked>
        <span>
          <v-icon class="only-whit e" icon="mdi-translate" size="small"></v-icon>
           <span class="text-xs only-whit e"> :{{ __t(currentName) }}</span> 
        </span>
      </v-btn> -->
    </template>

    <!-- Options List -->
    <v-list class="p-3" elevation="10" rounded="lg" bg-color="base">
      <v-list-item v-for="locale in allLocale" :key="locale.code" :value="locale.code"
        class="flex flex-col items-center justify-center my-auto rounded-lg"
        @click="changeLocale(locale.code, locale.href)">
        <v-list-item-title class="mx-3 my-2">
          {{ locale.properties.native }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
  <div v-else class="flex flex-col flex-wrap gap-2 p-2 mt-5">
    <v-btn v-for="locale in allLocale" :key="locale.code" :value="locale.code"
      @click="changeLocale(locale.code, locale.href)" :color="isDark ? 'white' : 'black'" variant="text">
      <v-icon icon="mdi-translate" size="small" class="mx-2"></v-icon>
      {{ locale.properties.native }}
    </v-btn>
  </div>
  <!-- item.href -->
</template>
